import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly logger: LoggerService) {}

  public handleError(error: unknown): void {
    this.logger.error('GlobalErrorHandler', 'Unhandled client error', error);
  }
}